module.exports = __webpack_public_path__ + "static/media/end-season.bb5f2a76.mp3";